import { url } from '@tencent/wphk-base-utils';

export enum UrlParamKey {
  /** 区域 */
  area = 'area',
  /** 展示 C2C 裂变弹窗 */
  showC2CDialog = 'showC2CDialog'
}

/**
 * 本页面统一从url模块获取qryParams，便于管理
 */
export const getUrlParamByKey = (paramKey: UrlParamKey) => url.getUrlParam(paramKey) || '';
